import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { TA } from "@/i18n/ta";

// Source-text keyed i18n: keys ARE the English strings.
// Missing Tamil entries fall back to the English key automatically (nothing breaks).
const saved = (typeof localStorage !== "undefined" && localStorage.getItem("lang")) || "en";

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: {} },
    ta: { translation: TA },
  },
  lng: saved,
  fallbackLng: "en",
  keySeparator: false,
  nsSeparator: false,
  interpolation: { escapeValue: false },
  returnEmptyString: false,
});

if (typeof document !== "undefined") document.documentElement.lang = saved;

export function setLanguage(lng) {
  i18n.changeLanguage(lng);
  if (typeof localStorage !== "undefined") localStorage.setItem("lang", lng);
  if (typeof document !== "undefined") document.documentElement.lang = lng;
}

export default i18n;
